module.exports = __webpack_public_path__ + "static/media/loader.f5dddfd2.svg";